import { memo, useMemo } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
// Import Enums
import { DisplayModeEnum } from 'enums';
// Import Helpers
import { generateInternalImageUrl } from 'services/Helpers';
// Import Constants
import { l } from 'constants/common';
// Import Styles
import styles from './templateModal.module.scss';

const CMS_BANNER_IMAGE_FALLBACK_HOST = 'https://cmsbetconstruct.com';

interface CMSBannerImagePreviewProps {
    body: string;
    displayMode: DisplayModeEnum;
}

const CMSBannerImagePreview = ({ body, displayMode }: CMSBannerImagePreviewProps) => {
    const { t } = useTranslation();

    const imageUrl = useMemo(() => {
        try {
            const parsed = JSON.parse(body);
            const src = parsed?.src;

            return generateInternalImageUrl(src, process.env.REACT_APP_CMS_URL || CMS_BANNER_IMAGE_FALLBACK_HOST);
        } catch {
            return null;
        }
    }, [body]);

    return (
        <div
            className={classNames(styles.cmsBannerImagePreview, {
                [styles.cmsBannerImagePreviewDark]: displayMode === DisplayModeEnum.DarkMode,
            })}
        >
            <div className={styles.cmsBannerPreviewBox}>
                {imageUrl ? (
                    <img className={styles.cmsBannerPreviewImage} src={imageUrl} alt={t(l.BannerImagePreview)} />
                ) : (
                    <span>{t(l.NA)}</span>
                )}
            </div>
        </div>
    );
};

export default memo(CMSBannerImagePreview);
